import { Injectable, inject } from '@angular/core';

import { MonitoringContext, MonitoringMessageOptions } from './monitoring.interface';
import { MONITORING } from './monitoring.token';

type CaptureMessage = (message: string, options: MonitoringMessageOptions) => void;

@Injectable({ providedIn: 'root' })
export class MonitoringLogger {
  private monitoring = inject(MONITORING, { optional: true });
  private captureMessage: CaptureMessage = (message, options) => this.monitoring?.captureMessage(message, options);

  error = (message: string, extra?: unknown, fingerprint?: string): void =>
    this.log(message, { level: 'error', extra: this.normalizeExtra(extra), fingerprint });
  info = (message: string, extra?: unknown, fingerprint?: string): void =>
    this.log(message, { level: 'info', extra: this.normalizeExtra(extra), fingerprint });
  warn = (message: string, extra?: unknown, fingerprint?: string): void =>
    this.log(message, { level: 'warning', extra: this.normalizeExtra(extra), fingerprint });
  action = (name: string, context?: MonitoringContext): void => this.monitoring?.action(name, context);

  protected setCaptureMessage(_captureMessage: CaptureMessage): void {
    this.captureMessage = _captureMessage;
  }

  private log(message: string, options: MonitoringMessageOptions): void {
    this.captureMessage(message, options);
  }

  private normalizeExtra(extra?: unknown): Record<string, unknown> | undefined {
    if (extra === undefined) {
      return undefined;
    }
    return typeof extra === 'object' && extra !== null ? (extra as Record<string, unknown>) : { value: extra };
  }
}
